<template>
	<section id="main-wrapper">
		<div class="sy-ch-main container-fluid">
			<h1 class = "mb2">Products</h1>
			<div class="mb3">
				<div :class="'sy-ms-btn bp-set' + (includedCat.includes(c) ? ' active' : '')" v-for = "c in categories" @click = "toggleCat(c)">
					{{c}}
				</div>
			</div>
			<!-- ADD -->
			<div v-if = "adding">
				<div class="mgt-15 text-left mb3">
					<div class="sy-ms-btn bp-set" @click = "cancel">Cancel</div>
					<div class="sy-ms-btn bp-set"  @click = "addSubmit">Add</div>
				</div>
				<table align="center" style="text-align:left;margin:auto;width: 100%;" class="container-fluid" >
					<tbody>
						<tr>
							<td>
								<label for="input-Name">Name</label>
								<input id = "input-Name" class = "form-control"  type = "text" placeholder = "Name" v-model.trim = " addForm['Name']">
								<p class = "font-red">{{ errorMsg['Name']}}</p>
							</td>
						</tr>
						<tr>
							<td>
								<label for="input-Name">Category</label>
								<select class = "form-control" v-model = "addForm['Category']">
									<option v-bind:value="c" v-for = "c in categories">{{c}}</option>
								</select>
								<p class = "font-red">{{errorMsg["Category"]}}</p>
							</td>
						</tr>
					</tbody>
				</table>

				<ejs-richtexteditor ref="rteObj" :height="400" placeholder = "Description">
				</ejs-richtexteditor>
				<table class = "table table-bordered">
					<tbody>
						<tr>
							<td>
								<label>
									Measurement (piece/kg/item/etc)
								</label>
								<input type = "text" class = "form-control" placeholder = "Measurement" v-model = "addForm['Measurement']">
								<p class = "font-red">{{errorMsg["Measurement"]}}</p>
							</td>
						</tr>
						<tr>
							<td>
								<label for="input-Price">Price</label>
								<input id = "input-Price" class = "form-control"  type = "number" placeholder = "Price" v-model.trim = " addForm['Price']">
								<p class = "font-red">{{ errorMsg['Price']}}</p>
							</td>
						</tr>
						<tr>
							<td>
								<label>
									Options
								</label>
								<br>
								<button class = "btn btn-sm btn-gradient-primary"  @click = "addElement('Options')">Add</button>
								<table class = "table table-bordered">
									<tr>
										<th>Name</th>
										<th>Choices</th>
										<th>nCompulsory</th>
										<th>nMax</th>
										<th> Actions </th>
									</tr>
									<tr v-for = "(element,elementIndex) in addForm['Options']">
										<td>
											<input type = "text" class = "form-control" placeholder = "Name" v-model = "addForm['Options'][elementIndex]['Name']">
											<p class = "font-red">{{errorMsg["Options"][elementIndex]["Name"]}}</p>
										</td>
										<td>
											<button class = "btn btn-sm btn-gradient-primary" @click = "addChoice(elementIndex);">Add</button>
											<table class = "table table-bordered">
												<thead>
													<tr>
														<th>Text</th>
														<th>Price Increase</th>
														<th> Actions </th>
													</tr>
												</thead>
												<tbody>
													<tr v-for = "(c, cIndex) in addForm['Options'][elementIndex]['Choices']">
														<td>
															<input type = "text" class = "form-control" placeholder = "Text" v-model = "c.Text">
															<p class = "font-red">{{errorMsg["Options"][elementIndex]["Choices"][cIndex]["Text"]}}</p>
														</td>
														<td>
															<input type = "number" class = "form-control" placeholder = "Price" v-model = "c.Price">
															<p class = "font-red">{{errorMsg["Options"][elementIndex]["Choices"][cIndex]["Price"]}}</p>
														</td>
														<td>
															<button class = "btn btn-sm btn-gradient-info" @click = "moveChoice(elementIndex, cIndex, -1)">Move Up</button>
															<button class = "btn btn-sm btn-gradient-info" @click = "moveChoice(elementIndex, cIndex, 1)">Move Down</button>
															<button class = "btn btn-sm btn-gradient-danger" @click = "removeChoice(elementIndex, cIndex)">Remove</button>
														</td>
													</tr>
												</tbody>
											</table>
										</td>
										<td>
											<input type = "number" class = "form-control" placeholder = "nCompulsory" v-model = "addForm['Options'][elementIndex]['nCompulsory']">
											<p class = "font-red">{{errorMsg["Options"][elementIndex]["nCompulsory"]}}</p>
										</td>
										<td>
											<input type = "number" class = "form-control" placeholder = "nMax" v-model = "addForm['Options'][elementIndex]['nMax']">
											<p class = "font-red">{{errorMsg["Options"][elementIndex]["nMax"]}}</p>
										</td>
										<td>
											<button class = "btn btn-sm btn-gradient-info" @click = "moveOption(elementIndex, -1)">Move Up</button>
											<button class = "btn btn-sm btn-gradient-info" @click = "moveOption(elementIndex, 1)">Move Down</button>
											<button class = "btn btn-sm btn-gradient-danger"  @click = "addForm['Options'].splice(elementIndex, 1); errorMsg['Options'].splice(elementIndex, 1)">Delete</button>
										</td>
									</tr>
								</table>

							</td>
						</tr>
						<tr>
							<td>
								<label for="input-EnableStock">EnableStock</label>
								<input id = "input-EnableStock" class = "form-control"  type = "checkbox" placeholder = "EnableStock" v-model.trim = " addForm['EnableStock']">
								<p class = "font-red">{{ errorMsg['EnableStock']}}</p>
							</td>
						</tr>
						<tr v-if = "addForm.EnableStock">
							<td>
								<label for="input-Price">Stock</label>
								<input id = "input-Stock" class = "form-control"  type = "number" placeholder = "Stock" v-model.trim = " addForm['Stock']">
								<p class = "font-red">{{ errorMsg['Stock']}}</p>
							</td>
						</tr>
						<tr>
							<td>
								<label for="input-Price">Available</label>
								<input type = "checkbox" placeholder = "Available" v-model = "addForm['Available']">
								<p class = "font-red">{{errorMsg["Available"]}}</p>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<!-- EDIT -->

			<div v-else-if = "editing">
				<div class="mgt-15 text-left mb3">
					<div class="sy-ms-btn bp-set" @click = "cancel">Cancel</div>
					<div class="sy-ms-btn bp-set"  @click = "editSubmit">Update</div>
				</div>
				<table align="center" style="text-align:left;margin:auto;width: 100%;" class="container-fluid" >
					<tbody>
						<tr>
							<td>
								<label for="input-Name">Name</label>
								<input id = "input-Name" class = "form-control"  type = "text" placeholder = "Name" v-model.trim = " editForm['Name']">
								<p class = "font-red">{{ errorMsg['Name']}}</p>
							</td>
						</tr>
						<tr>
							<td>
								<label for="input-Name">Category</label>
								<select class = "form-control" v-model = "editForm['Category']">
									<option v-bind:value="c" v-for = "c in categories">{{c}}</option>
								</select>
								<p class = "font-red">{{errorMsg["Category"]}}</p>
							</td>
						</tr>
					</tbody>
				</table>

				<ejs-richtexteditor ref="rteObj" :height="400" placeholder = "Description">
				</ejs-richtexteditor>
				<table class = "table table-bordered">
					<tbody>
						<tr>
							<td>
								<label>
									Measurement (piece/kg/item/etc)
								</label>
								<input type = "text" class = "form-control" placeholder = "Measurement" v-model = "editForm['Measurement']">
								<p class = "font-red">{{errorMsg["Measurement"]}}</p>
							</td>
						</tr>
						<tr>
							<td>
								<label for="input-Price">Price</label>
								<input id = "input-Price" class = "form-control"  type = "number" placeholder = "Price" v-model.trim = " editForm['Price']">
								<p class = "font-red">{{ errorMsg['Price']}}</p>
							</td>
						</tr>
						<tr>
							<td>
								<label for="input-EnableStock">EnableStock</label>
								<input id = "input-EnableStock"  type = "checkbox" placeholder = "EnableStock" v-model.trim = " editForm['EnableStock']">
								<p class = "font-red">{{ errorMsg['EnableStock']}}</p>
							</td>
						</tr>
						<tr>
							<td>
								<label>
									Options
								</label>
								<br>
								<button class = "btn btn-sm btn-gradient-primary"  @click = "addElement('Options')">Add</button>
								<table class = "table table-bordered">
									<tr>
										<th>Name</th>
										<th>Choices</th>
										<th>nCompulsory</th>
										<th>nMax</th>
										<th> Actions </th>
									</tr>
									<tr v-for = "(element,elementIndex) in editForm['Options']">
										<td>
											<input type = "text" class = "form-control" placeholder = "Name" v-model = "editForm['Options'][elementIndex]['Name']">
											<p class = "font-red">{{errorMsg["Options"][elementIndex]["Name"]}}</p>
										</td>
										<td>
											<button class = "btn btn-sm btn-gradient-primary" @click = "addChoice(elementIndex);">Add</button>
											<table class = "table table-bordered">
												<thead>
													<tr>
														<th>Text</th>
														<th>Price Increase</th>
														<th> Actions </th>
													</tr>
												</thead>
												<tbody>
													<tr v-for = "(c, cIndex) in editForm['Options'][elementIndex]['Choices']">
														<td>
															<input type = "text" class = "form-control" placeholder = "Text" v-model = "c.Text">
															<p class = "font-red">{{errorMsg["Options"][elementIndex]["Choices"][cIndex]["Text"]}}</p>
														</td>
														<td>
															<input type = "number" class = "form-control" placeholder = "Price" v-model = "c.Price">
															<p class = "font-red">{{errorMsg["Options"][elementIndex]["Choices"][cIndex]["Price"]}}</p>
														</td>
														<td>
															<button class = "btn btn-sm btn-gradient-info" @click = "moveChoice(elementIndex, cIndex, -1)">Move Up</button>
															<button class = "btn btn-sm btn-gradient-info" @click = "moveChoice(elementIndex, cIndex, 1)">Move Down</button>
															<button class = "btn btn-sm btn-gradient-danger" @click = "removeChoice(elementIndex, cIndex)">Remove</button>
														</td>
													</tr>
												</tbody>
											</table>
										</td>
										<td>
											<input type = "number" class = "form-control" placeholder = "nCompulsory" v-model = "editForm['Options'][elementIndex]['nCompulsory']">
											<p class = "font-red">{{errorMsg["Options"][elementIndex]["nCompulsory"]}}</p>
										</td>
										<td>
											<input type = "number" class = "form-control" placeholder = "nMax" v-model = "editForm['Options'][elementIndex]['nMax']">
											<p class = "font-red">{{errorMsg["Options"][elementIndex]["nMax"]}}</p>
										</td>
										<td>
											<button class = "btn btn-sm btn-gradient-info" @click = "moveOption(elementIndex, -1)">Move Up</button>
											<button class = "btn btn-sm btn-gradient-info" @click = "moveOption(elementIndex, 1)">Move Down</button>
											<button class = "btn btn-sm btn-gradient-danger"  @click = "editForm['Options'].splice(elementIndex, 1); errorMsg['Options'].splice(elementIndex, 1)">Delete</button>
										</td>
									</tr>
								</table>

							</td>
						</tr>
						<tr v-if = "editForm.EnableStock">
							<td>
								<label for="input-Price">Stock</label>
								<input id = "input-Stock" class = "form-control"  type = "number" placeholder = "Stock" v-model.trim = " editForm['Stock']">
								<p class = "font-red">{{ errorMsg['Stock']}}</p>
							</td>
						</tr>
						<tr>
							<td>
								<label for="input-Price">Available</label>
								<input type = "checkbox" placeholder = "Available" v-model = "editForm['Available']">
								<p class = "font-red">{{errorMsg["Available"]}}</p>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-else-if = "sorting" >
				<div class="mgt-15 text-left mb3">
					<div class="sy-ms-btn bp-set" @click = "cancel">Cancel</div>
					<div class="sy-ms-btn bp-set" @click = "sortEnd">Save Sequence</div>
				</div>

				<ul id = "PreorderProductsList">
					<li v-for = "(ID, index) in indices" v-bind:id = "ID">
						<img v-bind:src="items[ID].Photos && items[ID].Photos[0] ? items[ID].Photos[0].path : items[ID].Photo" alt="" style = "width: auto; height: 90px;" v-if = "items[ID].Photo != undefined && items[ID].Photo != ''">
						{{items[ID]["Name"]}}
					</li>
				</ul>
			</div>
			<div v-else-if = "editingPhotos" >
				<div class="mgt-15 text-left mb3">
					<div class="sy-ms-btn bp-set" @click = "cancel">Cancel</div>
					<div class="sy-ms-btn bp-set" @click = "editPhotosSubmit">Save Sequence</div>
				</div>
				{{editForm.Name}}
				<table id = "PhotosList">
					<tr v-for = "(photo, index) in editForm.Photos" :id = "index">
						<td>
							<img v-bind:src="photo.path" alt="" style = "width: auto; height: 90px;">
						</td>
						<td>
							<div class="sy-ms-btn bp-set" @click = "editForm.Photos.splice(index, 1)">Remove</div>
						</td>
					</tr>
				</table>
			</div>

			<div v-else>
				<div class="mgt-15 text-left mb3">
					<div class="sy-ms-btn bp-set" @click = "sortStart">Sort</div>
					<div class="sy-ms-btn bp-set" @click = "addStart">Add</div>

					<input class = "form-control mt2" placeholder="Search by Product Name or Category Name" type="text" v-model = "filterText">
				</div>
				<ul class="sy-ma-list" >
					<li v-for = "(ID, index) in indices" v-if = "includedCat.includes(items[ID].Category) && filterItem(items[ID], filterText)" >
						<div class="sy-ml-set">
							<div class="bp-img wide">
								<img :src="items[ID].Photos && items[ID].Photos[0] ? items[ID].Photos[0].path : items[ID].Photo" alt="" style = "width: auto; height: 100px;">
								<label :for="ID" class="btn-upload">
									Upload File
									<input class = "1" v-bind:id="ID" ref="fileSelect" type="file" title="" accept="image/*" :multiple="false" @change="setPhoto($event, items[ID], ID)"/>
								</label>
								<label :for="ID" class="btn-upload" @click = "editPhotos(items[ID], ID)">
									Edit Photos
								</label>

							</div>
							<div class="sy-ms-desc">
								<p class="mb1"><strong>{{items[ID]['Name']}}</strong></p>
								<p class="mb1">{{items[ID]['Category']}}</p>
								<div class="sy-ms-tag">
									<p v-html = "items[ID]['Description']"></p>
								</div>
							</div>
							<div class="sy-ms-num fz-18">
								<strong>{{formatPrice(items[ID]['Price'], "")}}</strong>
							</div>
							<div class="sy-ms-num">
								<div class="btn-toggle mb1 small" @click = "duplicate(items[ID])">
									Duplicate
								</div>
								<br>
								<div class="btn-toggle mb1 small" @click = "editStart(items[ID], ID, index)">
									Edit
								</div>
								<br>
								<div class="btn-toggle mb1 small" @click = "deleteItem(items[ID], ID, index)">
									Delete
								</div>
								<br>
								<div class="btn-toggle mb1 small" @click = "toggleBool(items[ID], ID, 'Available')" v-if = "items[ID].Available">
									Available
								</div>
								<div class="btn-toggle small" @click = "toggleBool(items[ID], ID, 'Available')" v-else>
									Unavailable
								</div>
							</div>

						</div>
					</li>
				</ul>
			</div>
		</div>
	</section>
</template>

<style>
@import "../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-lists/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-popups/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-buttons/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-navigations/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-vue-richtexteditor/styles/material.css";
</style>

<script>
import { RichTextEditorPlugin, Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar } from "@syncfusion/ej2-vue-richtexteditor";

import imageCompression from 'browser-image-compression';
import XLSX from "xlsx";
var md5 = require('md5');
var uuid = require('uuid/v5');
var dbPath = "settings";
var docID = "preOrderSetting";
var itemTemplate;
export default {
	provide: {
		richtexteditor:[Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar]
	},
	//==============================================//
	//												//
	//					DATA						//
	//												//
	//==============================================//
	data(){
		itemTemplate = [{"Name":"Name","checkFun":"text","children":[],"defaultValue":"","inputType":"text","manyView":true,"max":"","min":"","placeholder":"Name","singleView":true,"type":"Name"},{"Name":"Category","checkFun":"text","children":[],"defaultValue":"","inputType":"text","manyView":true,"max":"","min":"","placeholder":"Category","singleView":true,"type":"Text"},{"Name":"Description","checkFun":"none","children":[],"defaultValue":"","inputType":"textarea","manyView":true,"max":"","min":"","placeholder":"Description","singleView":true,"type":"Description"},{"Name":"Price","checkFun":"posNum","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Price","singleView":true,"type":"Price"},{"Name":"Available","checkFun":"none","children":[],"defaultValue":"true","inputType":"checkbox","manyView":true,"max":"","min":"","placeholder":"Available","singleView":true,"type":"Boolean"},{"Name":"Options","checkFun":"none","children":[{"Name":"Name","checkFun":"text","children":[],"defaultValue":"","inputType":"text","manyView":true,"max":"","min":"","placeholder":"Name","singleView":true,"type":"Name"},{"Name":"nCompulsory","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"nCompulsory","singleView":true,"type":"Price"},{"Name":"nMax","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"nMax","singleView":true,"type":"Price"},{"Name":"Choices","checkFun":"none","children":[],"defaultValue":"","inputType":"text","manyView":true,"max":"","min":"","placeholder":"Choices","singleView":true,"type":"Array"}],"defaultValue":"","inputType":"text","manyView":true,"max":"","min":"","placeholder":"Options","singleView":true,"type":"Array"},{"Name":"EnableStock","checkFun":"none","children":[],"defaultValue":"true","inputType":"checkbox","manyView":true,"max":"","min":"","placeholder":"EnableStock","singleView":true,"type":"Boolean"},{"Name":"Stock","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"checkbox","manyView":true,"max":"","min":"","placeholder":"Stock","singleView":true,"type":"Boolean"}];
		return{
			// FORM
			addForm: {},
			editForm: {},
			viewForm: {},
			errorMsg: {},

			// NAV VARIABLES
			adding: false,
			editing: false,
			viewing: false,
			sorting: false,
			editingPhotos: false,
			filterText: "",

			// PLACEHOLDER
			items: [],
			oriItem: {},
			indices: [],
			categories: [],
			editIndex: "",

			excelError: "",
			includedCat: [],

		}
	},

	firestore(){
		dbPath = "business/" + this.$route.params.businessID + "/settings";
		docID = "preOrderSetting";

		this.$binding("oriItem", myFB.getDoc(dbPath, docID)).then(r=>{
			this.items = myCopier.copy(this.oriItem["PreorderProducts"]) || {}
			this.indices = myCopier.copy(this.oriItem["PreorderProductsIndices"]) || []

			var cat = [];
			this.oriItem["PreorderCategoriesIndices"].forEach(r=>{
				cat.push(this.oriItem["PreorderCategories"][r].Name);
			})
			this.categories = cat;
			this.includedCat = myCopier.copy(cat);
		})
	},

	watch:{
		"oriItem"(){
			if (this.oriItem.PreorderCategoriesIndices != undefined){
				this.items = myCopier.copy(this.oriItem["PreorderProducts"]) || {}
				this.indices = myCopier.copy(this.oriItem["PreorderProductsIndices"]) || []

				var cat = [];
				this.oriItem["PreorderCategoriesIndices"].forEach(r=>{
					cat.push(this.oriItem["PreorderCategories"][r].Name);
				})
				this.categories = cat;

			}
		},
	},
	//==============================================//
	//												//
	//					METHODS						//
	//												//
	//==============================================//
	methods:{
		//------------------------------ SORT -------------------------------//
		toggleCat(c){
			if (this.categories.length === this.includedCat.length){
				this.includedCat = [c];
			}
			else if (this.includedCat.length === 1){
				if (this.includedCat.includes(c)){
					this.includedCat = myCopier.copy(this.categories);
				}
				else{
					this.includedCat.push(c);
				}
			}
			else if (this.includedCat.includes(c)){
				this.includedCat.splice(this.includedCat.indexOf(c), 1);
			}
			else{
				this.includedCat.push(c);
			}
		},
		sortStart(){
			this.sorting = true;
			setTimeout(()=>{
				var sortable = $("#PreorderProductsList").sortable({
					delay: 50,
					disable: false
				});
				sortable.sortable("enable");
			}, 300);
		},
		sortEnd(){
			var arr = $( "#PreorderProductsList").sortable("toArray");
			var sortable = $("#PreorderProductsList").sortable("cancel");
			sortable.sortable("disable");
			var update = {};
			update["PreorderProductsIndices"] = arr;
			myFB.updateDoc(dbPath, update, docID, this);				
			this.sorting = false;
		},
		sortCancel(){
			var sortable = $("#PreorderProductsList").sortable("cancel");
			sortable.sortable("disable");
			this.sorting = false;
		},
		//------------------------------ PHOTO -------------------------------//
		editPhotos(item, ID){
			this.editForm = {
				Name: item.Name,
				Photos: myCopier.copy(item.Photos || []),
				ID: ID
			}
			this.editingPhotos = true;
			this.$nextTick(()=>{
				var sortable = $("#PhotosList").sortable({
					delay: 50,
					disable: false
				});
				sortable.sortable("enable");
			})
		},
		editPhotosSubmit(){
			var arr = $( "#PhotosList").sortable("toArray");
			var update = {};
			var fieldName = "PreorderProducts." + this.editForm.ID + ".Photos";
			update[fieldName] = [];
			arr.forEach(ind=>{
				update[fieldName].push(this.editForm.Photos[parseInt(ind)]);
			})

			var oldIDs = this.items[this.editForm.ID].Photos.map(r=>{
				return r.ID;
			});
			var newIDs = update[fieldName].map(r=>{
				return r.ID;
			})
			oldIDs.filter(r=>{
				return !newIDs.includes(r);
			}).forEach(ID=>{
				console.log(ID);
				myFB.storage.ref(dbPath + "/preorder/" + ID).delete();
			})


			myFB.updateDoc(dbPath, update, docID, this, "Updating photo...", "Photo updated!");
			this.cancel();
		},
		async setPhoto(e, item, ID){
			const options = { 
				maxSizeMB: 1,          
				maxWidthOrHeight: 1200,
			}
			var update = {};
			let fileList = e.target.files || e.dataTransfer.file;

			// if (item.Photo != undefined && item.Photo != ''){
			// 	myFB.storage.ref(dbPath + "/preorder/" + ID).delete();
			// 	// update["PreorderProducts." + ID + ".Photo"] = myFB.fieldVal.delete();
			// }
			// var file = await imageCompression(fileList[0], options);
			// var url = await this.uploadFile(file, dbPath + "/preorder/" + ID);
			// update["PreorderProducts." + ID + ".Photo"] = url;
			// MULTI
			var processes = [];
			for (var file of fileList){
				processes.push(imageCompression(file, options));
			}
			var compressedFiles = await Promise.all(processes).then(r=>{
				return r;
			});
			update["PreorderProducts." + ID + ".Photos"] = await Promise.all(compressedFiles.map(async file=>{
				var newID = myFB.getCol("wow").doc().id;
				return {
					path: await this.uploadFile(file, dbPath + "/preorder/" + newID),
					ID: newID
				}
			})).then(r=>{
				return r;
			})
			if (item.Photos){
				update["PreorderProducts." + ID + ".Photos"] = myFB.fieldVal.arrayUnion(...update["PreorderProducts." + ID + ".Photos"]);
			}
			else if (item.Photo){
				update["PreorderProducts." + ID + ".Photos"].push({
					ID: ID,
					path: item.Photo
				})
			}
			myFB.updateDoc(dbPath, update, docID, this, "Updating photo...", "Photo updated!");
		},
		async uploadFile(f, path){
			var fileURL = "";

			console.log("Uploading to " + path);
			await myFB.storage.ref(path).put(f).then(async r=>{
				await r.ref.getDownloadURL().then(async url=>{
					fileURL = url;
				})
			});
			return fileURL;
		},
		//------------------------------ FORMAT ------------------------------//
		formatDate(input){
			var mode = {
				sequence: "d m y",
				monthMode: 2,
			}
			return myDate.displayDate(input, mode);
		},
		formatDateTime(input){
			var mode = {
				sequence: "d m y",
				monthMode: 2,
			}
			return myDate.displayDateTime(input, mode, {sequence: "hh:mm"});
		},
		formatPrice(input, prefix){
			var prefix = prefix || "";
			return myPrice.display(input, prefix)
		},
		//-------------------------------- FILTERS --------------------------------//
		filterItem(item, text){
			var filter = text.toUpperCase();
			var name = (item["Name"]).toString().toUpperCase().includes(filter);
			var category = (item["Category"]).toString().toUpperCase().includes(filter);
			var description = (item["Description"]).toString().toUpperCase().includes(filter);
			var price = (item["Price"]).toString().toUpperCase().includes(filter);
			var available = (item["Available"]).toString().toUpperCase().includes(filter);
			return name || category || description || price || available;
		},
		//-------------------------------- CREATE -------------------------------//
		duplicate(item){
			var editForm = myCopier.copy(item);
			delete editForm[".key"];
			var response = myInput.editMain(editForm, itemTemplate);
			this.addForm = response.output;
			if (response.output.Measurement == ""){
				this.addForm.Measurement = "piece";
			}
			this.addForm.Photo = "";
			this.addForm.Photos = [];
			this.errorMsg = myCopier.copyAs(this.addForm, "");
			this.adding = true;
		},
		addStart(){
			var response = myInput.init(itemTemplate);
			this.errorMsg = response.errorMsg;
			this.addForm = response.output;
			this.addForm.Measurement = "piece";
			this.addForm.Available = true;
			this.adding = true;
		},
		addSubmit(){
			var response;
			var allowAdd = true;
			var checkFun = itemTemplate, addForm = myCopier.copy(this.addForm);
			addForm.Description = this.$refs.rteObj.ej2Instances.value || "";
			response = myInput.checkMain(addForm, checkFun);

			if (response.error){
				allowAdd = false;
			}

			addForm.Options.forEach((o,oIndex) =>{
				if (o.nCompulsory < 0){
					allowAdd = false;
					response.errorMsg.Options[oIndex].nCompulsory = "Value cannot be below 0.";
				}
				if (o.nMax < 0){
					allowAdd = false;
					response.errorMsg.Options[oIndex].nCompulsory = "Value cannot be below 0.";
				}
				if (o.nMax < o.nCompulsory){
					allowAdd = false;
					response.errorMsg.Options[oIndex].nCompulsory = "Value cannot be greater than nMax.";
				}
				if (o.nCompulsory > o.Choices.length){
					allowAdd = false;
					response.errorMsg.Options[oIndex].nCompulsory = "Value cannot be greater than number of choices.";
				}
				response.errorMsg["Options"][oIndex]["Choices"] = [];
				o.Choices.forEach((r,cIndex) =>{
					response.errorMsg["Options"][oIndex]["Choices"].push({
						Text: "",
						Price: ""
					})
					if (r.Text == "" || r.Text == undefined){
						allowAdd = false; 
						response.errorMsg["Options"][oIndex]["Choices"][cIndex]["Text"] = "Value is empty.";
					}
					if (r.Price == "" || r.Price == undefined){
						allowAdd = false; 
						response.errorMsg["Options"][oIndex]["Choices"][cIndex]["Price"] = "Value is empty.";
					}
				})
			})
			this.errorMsg = response.errorMsg;

			if (allowAdd){

				var ID = uuid(Date() + Math.random(), uuid.DNS);
				var update = {};
				update["PreorderProducts." + ID] = response.output;
				update["PreorderProductsIndices"] = myFB.fieldVal.arrayUnion(ID);
				myFB.updateDoc(dbPath, update, docID, this, "Creating PreorderProducts...", "PreorderProducts created!");
				this.cancel();
			}
		},
		//------------------------------ UPDATE ------------------------------//
		editStart(item, ID, docIndex){
			var editForm = myCopier.copy(item);
			delete editForm[".key"];
			var response = myInput.editMain(editForm, itemTemplate);
			this.editForm = response.output;
			if (response.output.Measurement == ""){
				this.editForm.Measurement = "piece";
			}
			this.errorMsg = myCopier.copyAs(this.editForm, "");
			this.editIndex = ID;
			this.editing = true;
			this.$nextTick(()=>{
					this.$refs.rteObj.ej2Instances.value = myCopier.copy(this.editForm.Description);
			})
		},
		editSubmit(){
			var response;
			var allowAdd = true;
			var checkFun = itemTemplate, editForm = myCopier.copy(this.editForm);
			editForm.Description = this.$refs.rteObj.ej2Instances.value || "";
			response = myInput.checkMain(editForm, checkFun);
			this.errorMsg = response.errorMsg;
			if (response.error){
				allowAdd = false;
			}
			editForm.Options.forEach((o,oIndex) =>{
				if (o.nCompulsory < 0){
					allowAdd = false;
					response.errorMsg.Options[oIndex].nCompulsory = "Value cannot be below 0.";
				}
				if (o.nMax < 0){
					allowAdd = false;
					response.errorMsg.Options[oIndex].nCompulsory = "Value cannot be below 0.";
				}
				if (o.nMax < o.nCompulsory){
					allowAdd = false;
					response.errorMsg.Options[oIndex].nCompulsory = "Value cannot be greater than nMax.";
				}
				if (o.nCompulsory > o.Choices.length){
					allowAdd = false;
					response.errorMsg.Options[oIndex].nCompulsory = "Value cannot be greater than number of choices.";
				}
				response.errorMsg["Options"][oIndex]["Choices"] = [];
				o.Choices.forEach((r,cIndex) =>{
					response.errorMsg["Options"][oIndex]["Choices"].push({
						Text: "",
						Price: ""
					})
					if (r.Text == "" || r.Text == undefined){
						allowAdd = false; 
						response.errorMsg["Options"][oIndex]["Choices"][cIndex]["Text"] = "Value is empty.";
					}
					if (r.Price == "" || r.Price == undefined){
						allowAdd = false; 
						response.errorMsg["Options"][oIndex]["Choices"][cIndex]["Price"] = "Value is empty.";
					}
				})
			})
			this.errorMsg = response.errorMsg;
			if (allowAdd){
				var ID = this.editIndex;
				var update = {};
				update["PreorderProducts." + ID] = response.output;
				myFB.updateDoc(dbPath, update, docID, this, "Updating..." , "Updated!");
				this.cancel();
				this.cancel();
			}
		},
		toggleBool(item, ID, fieldName){
			var update = {};
			update["PreorderProducts." + ID + "." + fieldName] = !item[fieldName];
			myFB.updateDoc(dbPath, update , docID);
		},
		//----------------------------- BACK -----------------------------//
		cancel(){
			this.viewing = false;
			this.adding = false;
			this.editing = false;
			this.sorting = false;
			this.editingPhotos = false;
		},
		addElement(elementName, elementIndex){
			var temp;
			itemTemplate.forEach(r=>{
				if (r.Name == elementName){
					temp = r.children;
				}
			})
			var newElement = myInput.init(temp);
			if (this.adding){
				this.errorMsg[elementName].push(newElement.errorMsg);
				this.addForm[elementName].push(newElement.output);
			}
			else{
				this.errorMsg[elementName].push(newElement.errorMsg);
				this.editForm[elementName].push(newElement.output);
			}
		},
		moveOption(elementIndex, mode){
			var oriOptions;
			var tempOption;
			if (this.adding){
				oriOptions = myCopier.copy(this.addForm.Options);
			}
			else{
				oriOptions = myCopier.copy(this.editForm.Options);
			}
			if (mode>0){
				if (elementIndex < oriOptions.length - 1){
					tempOption = myCopier.copy(oriOptions[elementIndex])
					oriOptions[elementIndex] = myCopier.copy(oriOptions[elementIndex + 1]);
					oriOptions[elementIndex + 1] = tempOption;
				}
			}
			else if (elementIndex > 0){
				tempOption = myCopier.copy(oriOptions[elementIndex])
				oriOptions[elementIndex] = myCopier.copy(oriOptions[elementIndex -1]);
				oriOptions[elementIndex -1] = tempOption;
			}

			if (this.adding){
				this.addForm.Options = oriOptions;
				this.errorMsg.Options = myCopier.copyAs(oriOptions, "");
			}
			else{
				this.editForm.Options = oriOptions;
				this.errorMsg.Options = myCopier.copyAs(oriOptions, "");
			}
		},
		addChoice(elementIndex){
			this.errorMsg["Options"][elementIndex]["Choices"].push({
				Text: "",
				Price: "",
			});
			if (this.adding){
				this.addForm["Options"][elementIndex]["Choices"].push({
					Text: "",
					Price: "0",
				});
			}
			else{
				this.editForm["Options"][elementIndex]["Choices"].push({
					Text: "",
					Price: "0",
				});
			}
		},
		removeChoice(elementIndex, cIndex){
			if (this.adding){
				this.addForm["Options"][elementIndex]["Choices"].splice(cIndex, 1);
			}
			else{
				this.editForm["Options"][elementIndex]["Choices"].splice(cIndex, 1);
			}
			this.errorMsg["Options"][elementIndex]["Choices"].splice(cIndex, 1);
		},
		moveChoice(elementIndex, cIndex, mode){
			var oriChoices;
			var tempChoice;
			if (this.adding){
				oriChoices = myCopier.copy(this.addForm.Options[elementIndex].Choices);
			}
			else{
				oriChoices = myCopier.copy(this.editForm.Options[elementIndex].Choices);
			}
			if (mode>0){
				if (cIndex < oriChoices.length - 1){
					tempChoice = myCopier.copy(oriChoices[cIndex])
					oriChoices[cIndex] = myCopier.copy(oriChoices[cIndex + 1]);
					oriChoices[cIndex + 1] = tempChoice;
				}
			}
			else if (cIndex > 0){
				tempChoice = myCopier.copy(oriChoices[cIndex])
				oriChoices[cIndex] = myCopier.copy(oriChoices[cIndex -1]);
				oriChoices[cIndex -1] = tempChoice;
			}

			if (this.adding){
				this.addForm.Options[elementIndex].Choices = oriChoices;
				this.errorMsg.Options[elementIndex].Choices = myCopier.copAs(oriChoices, "");
			}
			else{
				this.editForm.Options[elementIndex].Choices = oriChoices;
				this.errorMsg.Options[elementIndex].Choices = myCopier.copAs(oriChoices, "");
			}
		},
		//----------------------------- RD -----------------------------//
		viewStart(item){
			var editForm = myCopier.copy(item);
			delete editForm[".key"];
			var response = myInput.editMain(editForm, itemTemplate);
			this.viewForm = response.output;
			this.viewing = true;
		},
		deleteItem(item, ID){
			if (confirm("Confirm deleting?")){
				if (item.Photo != "" && item.Photo != undefined){
					myFB.storage.ref(dbPath + "/preorder/" + ID).delete();
				}
				var update = {};
				update["PreorderProducts." + ID] = myFB.fieldVal.delete();
				update["PreorderProductsIndices"] = myFB.fieldVal.arrayRemove(ID);
				myFB.updateDoc(dbPath, update, docID, this, "Deleting..." , "Deleted!");
			};
		},
		//----------------------------- EXCEL -----------------------------//
		uploadExcel(e) {
			this.excelError = ""
			let fileList = e.target.files || e.dataTransfer.file
			Array.from(Array(fileList.length).keys()).map(x => {
				this.upload(fileList[x])
			})
		},
		upload(file){
			var reader = new FileReader();
			var json_object, field;
			var allowAdd = true;
			var response;
			reader.onload = (e => {
				var data = e.target.result;
				var workbook = XLSX.read(data,
				{
					type: "binary"
				});
				var allItems = {};
				var response;
				var allowAdd = true;
				var checkFun = itemTemplate, editForm = myCopier.copy(this.editForm);
				workbook.SheetNames.forEach((sheetName,sheetIndex) => {
					var XL_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
					json_object = XL_row_object;
					json_object.forEach( (obj, objectIndex) =>{
						var nameNow = obj.ID || uuid(Date() + Math.random(), uuid.DNS);
						obj.Price = obj.Price.replace("RM", "");
						obj.Price = obj.Price.replace(/ /, "");
						obj.Options = [];
						try{
							if (allItems[nameNow] == undefined){
								response = myInput.checkMain(obj, checkFun);
								if (response.error){allowAdd = false;
									this.excelError += "Sheet " + (sheetIndex + 1).toString() + ", row " + (objectIndex + 2).toString() + " : "; 
									for (var it in response.errorMsg){
										if (response.errorMsg[it] != ''){
											this.excelError += it + "(" + response.errorMsg[it] + "), ";
										}
									}
									this.excelError += "\n";
								}
								else{
									allItems[nameNow] = response.output
								}
							}
						}
						catch(e){
							console.log(e.message)
							allowAdd = false;
							this.excelError += "Sheet " + (sheetIndex + 1).toString() + ", row " + (objectIndex + 2).toString() + " : Unknown error. Please refresh the page and try again.\n"; 
						}
					});
				});
				if (allowAdd){
					var update = {};
					var updateID = myCopier.copy(this.indices) || [];
					for (var item in allItems){
						update["PreorderProducts." + item] = allItems[item];
						if (!updateID.includes(item)){
							updateID.push(item);
						}
					}
					update["PreorderProductsIndices"] = updateID;
					myFB.updateDoc(dbPath, update, docID, this, "Creating...", "Created!"); 
				}
			});
			reader.onerror = function(ex) {
				console.log(ex);
			};
			reader.readAsBinaryString(file);
		},
		downloadExcel(includeData){
			const XLSX = require("xlsx");
			var field, field2;
			var allTitles = [[]];
			var wb = XLSX.utils.book_new();
			wb.Props = {
				Title: "Template",
				Subject: "Test",
				Author: "TeioRei",
				CreatedDate: new Date()
			};
			var defaultValues = [];
			var varIndex = 0;
			var nVariations = 0;
			wb.SheetNames.push("Test Sheet");
			
			allTitles[0].push("ID");
			allTitles[0] = [
				"ID",
				"Name",
				"Category",
				"Description",
				"Measurement",
				"Price",
				"Available",
				"Featured",
			];

			if (includeData){
				this.indices.forEach(i=>{
					allTitles.push([
						this.items[i]["ID"],
						this.items[i]["Name"],
						this.items[i]["Category"],
						this.items[i]["Description"],
						this.items[i]["Measurement"],
						this.items[i]["Price"],
						this.items[i]["Available"],
						this.items[i]["Featured"],
					])
				})
			}

			wb.Sheets["Test Sheet"] = XLSX.utils.aoa_to_sheet(allTitles);
			var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
			var buf = new ArrayBuffer(wbout.length); 
			var view = new Uint8Array(buf);  
			for (var i=0; i<wbout.length; i++) {
				view[i] = wbout.charCodeAt(i) & 0xFF;
			} 
			saveAs(new Blob([buf],{type:"application/octet-stream"}), 'PreorderProducts-template.xlsx');
		},
	}
};
</script>


// WEBPACK FOOTER //
// src/components/Manager/ProductsAlone.vue